import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import Logo from '../../Logo/Logo';
import NavItems from '../NavItems/NavItems';
import Hamburger from './HamburgerMenu/Hambergur';

const MOBILE_NAV_HEIGHT = '4.2rem';

const Header = styled.header`
  position: fixed;
  inset: 0 0 auto;
  z-index: 120;
  min-height: calc(${MOBILE_NAV_HEIGHT} + env(safe-area-inset-top));
  display: none;
  align-items: center;
  padding: calc(env(safe-area-inset-top) + 0.4rem) 0.85rem 0.45rem;
  background: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  box-shadow: 0 .35rem 1.4rem rgba(0,0,0,.045);
  backdrop-filter: blur(20px);

  @media (max-width: 56rem) {
    display: flex;
  }
`;

const HeaderInner = styled.div`
  width: 100%;
  min-height: 3.35rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .8rem;
`;

const Backdrop = styled.button`
  position: fixed;
  inset: calc(${MOBILE_NAV_HEIGHT} + env(safe-area-inset-top) + 0.1rem) 0 0;
  z-index: 108;
  display: ${({ $opened }) => ($opened ? 'block' : 'none')};
  width: 100%;
  border: 0;
  background: rgba(0, 0, 0, 0.52);
  backdrop-filter: blur(4px);
`;

const Panel = styled.aside`
  position: fixed;
  z-index: 110;
  top: calc(${MOBILE_NAV_HEIGHT} + env(safe-area-inset-top));
  right: 0;
  width: min(88vw, 22rem);
  height: calc(100dvh - (${MOBILE_NAV_HEIGHT} + env(safe-area-inset-top)));
  padding: 1rem 1rem calc(1rem + env(safe-area-inset-bottom));
  background: #090909;
  box-shadow: -1rem 0 3rem rgba(0, 0, 0, 0.26);
  transform: translateX(${({ $opened }) => ($opened ? '0' : '105%')});
  visibility: ${({ $opened }) => ($opened ? 'visible' : 'hidden')};
  transition: transform 220ms ease, visibility 220ms ease;
  overflow-y: auto;
`;

function SideDrawer({ loggedIn }) {
  const [isOpened, setIsOpened] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isOpened ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpened]);

  return (
    <>
      <Header>
        <HeaderInner>
          <Logo />
          <Hamburger opened={isOpened} clicked={() => setIsOpened((open) => !open)} />
        </HeaderInner>
      </Header>
      <Backdrop
        type="button"
        $opened={isOpened}
        aria-label="Fermer le menu"
        onClick={() => setIsOpened(false)}
      />
      <Panel $opened={isOpened} aria-hidden={!isOpened}>
        <NavItems
          loggedIn={loggedIn}
          mobile
          clicked={() => setIsOpened(false)}
        />
      </Panel>
    </>
  );
}

export default SideDrawer;
